import { Component } from '@angular/core';

@Component({
  selector: 'no-candidacy',
  templateUrl: './no-candidacy.component.html'
})

export class NoCandidacyComponent {
}
